import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';

import { Favorito } from './../models/favorito.model';
import { Material } from '../models/material.model';

@Injectable({
  providedIn: 'root'
})

export class FavoritosService {
  public cookie = {Login:''}; // só pra não dar erro na hora de compilar
  // public cookie = JSON.parse(this._cookie.get('portal') || '{User: {FullName: 'LOGIN', Tipo: 'Nenhum'}}');
  private url = 'http://189.126.197.169/node/servicesctrl_dev_2/ebookfocus/';
  // private url = '//services.focustextil.com.br/node/servicesctrl_dev_2/ebookfocus/';

  private favListSource = new BehaviorSubject([]);
  favoritosList = this.favListSource.asObservable();

  constructor(
    private http: HttpClient,
    private _cookie: CookieService
  ) { }

  listFav(): Observable<Favorito[]> {
    return this.http.get<any>(this.url + 'listfav/' + this.cookie.Login.toLowerCase());
  }

  addFav(item): Observable<Favorito[]> {
    const requestOptions: Object = {
      responseType: 'text'
    }
    let newItem;
    newItem = {
      'MATNR': item.MATNR,
      'MAKTX': item.MAKTX,
      'CODIGO_PANTONE': item.CODIGO_PANTONE,
      'GRUPO': item.GRUPO,
      'SGRUPO': item.SGRUPO
    }
    let response = this.http.post<any>(
      this.url + 'addfavorito',
      {
        // Login: this.cookie.LOGIN.toLowerCase(),
        App: "ebookfocus",
        Item: newItem
      },
      requestOptions
    );
    let favoritos = [{"Itens":[]}];
    if (localStorage.favoritos != undefined) {
      favoritos = JSON.parse(localStorage.favoritos);
    }
    favoritos[0].Itens.push(newItem);
    localStorage.setItem('favoritos', JSON.stringify(favoritos));
    this.favListSource.next(favoritos[0].Itens.map(result => result.MATNR));
    return response;
  }

  removeFav(item): Observable<Favorito[]> {
    const requestOptions: Object = {
      responseType: 'text'
    }
    let response = this.http.post<any>(
      this.url + 'removerfavorito',
      {
        // Login: this.cookie.LOGIN.toLowerCase(),
        App: "ebookfocus",
        MATNR: item.MATNR
      },
      requestOptions
    );
    let favoritos = JSON.parse(localStorage.favoritos);
    favoritos[0].Itens = favoritos[0].Itens.filter(obj => obj.MATNR !== item.MATNR);
    localStorage.setItem('favoritos', JSON.stringify(favoritos));
    this.favListSource.next(favoritos[0].Itens.map(result => result.MATNR));
    return response;
  }

  favAll(list: Observable<Material[]>): Observable<any> {
    const requestOptions: Object = {
      responseType: 'text'
    }
    let listMap;
    list.subscribe(val => {
      listMap = val;
    });
    var itemList = listMap.map(function(item) {
      return {
        'MATNR': item.MATNR,
        'MAKTX': item.MAKTX,
        'CODIGO_PANTONE': item.CODIGO_PANTONE,
        'GRUPO': item.GRUPO,
        'SGRUPO': item.SGRUPO
      };
    });
    let response = this.http.post<any>(
      this.url + 'addallfavorito',
      {
        // Login: this.cookie.LOGIN.toLowerCase(),
        App: "ebookfocus",
        ItemList: itemList
      },
      requestOptions
    );
    let favoritos = JSON.parse(localStorage.favoritos);
    favoritos[0].Itens = favoritos[0].Itens.concat(itemList);
    favoritos[0].Itens = Object.values(favoritos[0].Itens.reduce((acc,cur)=>Object.assign(acc,{[cur.MATNR]:cur}),{}));
    localStorage.setItem('favoritos', JSON.stringify(favoritos));
    this.favListSource.next(favoritos[0].Itens.map(result => result.MATNR));
    return response;
  }

  removeAllFav(): Observable<Favorito[]> {
    const requestOptions: Object = {
      responseType: 'text'
    }
    let response =  this.http.post<any>(
      this.url + 'removerfavorito',
      {
        // Login: this.cookie.LOGIN.toLowerCase(),
        App: "ebookfocus",
        MATNR: 'TODOS'
      },
      requestOptions
    );
    localStorage.removeItem('favoritos');
    this.favListSource.next([]);
    return response;
  }
}